import React from 'react';
import * as PropTypes from 'prop-types';

import { classNamer, classes } from '../../lib/utils';

import './CareerList.scss';
import { Button, BUTTON_VARIANTS } from '../widgets/Button';
import i18n from '../../translations/i18n';

const cn = classNamer('CareerList');

const CareerCard = ({ career, index }) => (
  <li
    className={classes(cn('career'), 'magnify--small')}
    key={career.id}
    data-wow-delay={(index + 1) * 0.2 + 's'}
  >
    <a href={career.link} target="_blank" className="wow animated fadeInUpSmall">
      <div className="header">
        <h4 className="role">
          {career.role}{' '}
          {!career.published_at && <span className="text-danger">({i18n.unpublished})</span>}
        </h4>
        <Button className="btn-apply hide-xs" variant={BUTTON_VARIANTS.primary}>
          Apply
        </Button>
      </div>
      <p className="summary">{career.summary}</p>
      <Button className="btn-apply show-xs" variant={BUTTON_VARIANTS.primary}>
        Apply
      </Button>
    </a>
  </li>
);

const CareerList = ({ careers }) => {
  if (!careers.length) {
    return <p className={cn('no-careers')}>{i18n.noOpenPositions}</p>;
  }
  return (
    <ul className={cn('container')}>
      {careers.map((career, index) => (
        <CareerCard key={career.id} career={career} index={index} />
      ))}
    </ul>
  );
};

CareerList.propTypes = {
  careers: PropTypes.array.isRequired,
};

export default CareerList;
